import React, {Component} from 'react'
import PropTypes from 'prop-types'
import CompleteRegistrationTemplate from "./template";
import {bindActionCreators} from "redux"
import {connect} from 'react-redux'
import {FORM_REGISTRATION} from "../../redux/actions-reducers/form-registration/reducer";
import createFormActions from "../../redux/actions-reducers/form/create-form-actions";
import PersonRequests from "../../requests/person-requests";
import _ from 'lodash'
import md5 from 'md5'
import {PersonTypeEnum} from "../../enums/PersonTypeEnum";

//import './style.css'
const formActions = createFormActions(FORM_REGISTRATION)


class CompleteRegistrationPage extends Component {


    state = {
        awaiting: false,
        userNotFound: false,
        withoutEmail: false,
        withoutRelease: false,
        alreadyHasPassword: false,
        user: null,
        releaseCode: null,
    }

    componentDidMount() {
        const email = _.get(this.props.match, 'params.email')
        const releaseCode = _.get(this.props.match, 'params.releaseCode')

        if (!email)
            return this.setState({withoutEmail: true})

        if (!releaseCode)
            return this.setState({withoutRelease: true})

        const self = this
        this.setState({releaseCode}, () => {
            PersonRequests.search({email}, true)
                .then(this.handleSearchPersonResult)
                .catch(self.onError)
        })

    }

    handleSearchPersonResult = (user) => {


        if (!user)
            return this.setState({userNotFound: true})


        if (!!user.password )
           this.goToCoursePage()

        delete user.password
        this.props.updateFormValues(user)
        this.setState({user})

    }

    onSubmit = () => {
        this.props.validateForm()

        if (!this.props.form.valid)
            return

        if (this.state.awaiting)
            return

        this.setState({awaiting: true}, () => {

            const dto = {
                ...this.state.user,
                ...this.props.form.values,
            }

            delete dto.confirmPassword

            dto.password = md5(dto.password)

            PersonRequests.save(dto)
                .then(this.handleSaveResult)
                .catch(this.onError)
        })
    }


    handleSaveResult = (result) => {

        console.log(result )
        if (!result.success)
            return this.onError(_.get(result, 'errorMessages[0]'))


        const types = _.get(result, 'types', '')
        const isTeacher = types.split('|').some(type => type === PersonTypeEnum.TEACHER + '')

        this.props.context.set({
            person: result,
            isTeacher,
        }, () => {
            this.goToCoursePage()
        })


    }


    goToCoursePage = () => {
        const { releaseCode} = this.state
        this.props.history.push('/curso/' + releaseCode)
    }

    onError = (error) => {


        console.error(error)

        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: error + '' || 'Ocorreu um erro com o servidor.'
            }
        })

        this.setState({awaiting:false })
    }


    render() {
        const {
            title,
            match,
            context,
        } = this.props

        const {
            user,
            userNotFound,
            withoutEmail,
            withoutRelease,
            awaiting,
        } = this.state

        if (withoutEmail)
            return <h3 style={{padding: '2rem'}}>Email não encontrado.</h3>

        if (withoutRelease)
            return <h3 style={{padding: '2rem'}}>Sem curso para redirecionar.</h3>

        if (userNotFound)
            return <h3 style={{padding: '2rem'}}>Usuário não encontrado.</h3>


        const loginBackground = _.get(context, 'systemConfigParameterValue.loginBackground', null)

        return (
            <div style={{opacity: !!user ? 1 : 0}}>
                <CompleteRegistrationTemplate loginBackground={loginBackground}
                                              onSubmit={this.onSubmit}
                                              awaiting={awaiting}

                />
            </div>
        )
    }
}

CompleteRegistrationPage.propTypes = {
    validateForm: PropTypes.func,
}

CompleteRegistrationPage.defaultProps = {}

const mapStateToProps = (state) => {
    return {
        form: state[FORM_REGISTRATION]
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    validateForm: formActions.validate,
    updateFormValues: formActions.patchValues,
}, dispatch)


export default connect(mapStateToProps, mapDispatchToProps)(CompleteRegistrationPage)



// WEBPACK FOOTER //
// ./src/_pages/CompleteRegistration/page.js